import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiIconButton-label {
    text-decoration: underline;
    font-size: 18px;
  }

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  padding: 24px 18px;
  max-width: 616px;
  margin: 0 auto;

  a {
    color: ${COLOR.GREEN_1};
    text-decoration: underline;
  }

  p, a {
    margin: 18px 0;
  }

  & > button:first-of-type {
    width: 100%;
    margin: 30px 0 0;
  }

  h3 {
    margin: 0.5rem 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

export const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 40px;

  .MuiOutlinedInput-root {
    width: 100%;
    margin: 0;
  }

  button {
    margin: 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 75px;
    border-radius: 0 6px 6px 0;
  }
`;
